/**
 * Expose data and methods to handle position offsets (click/hold).
 *
 * Depends on:
 *   - this.show (bool)
 *   - this.positionXField (OverlayOptionsField): RANGE
 *   - this.positionYField (OverlayOptionsField): RANGE
 */
export default {
  data() {
    return {
      showPositionButtonsMenu: false,

      // Usually applied as vh/vw in the HTML. This is optionally
      // overwritten by individual stepsizes for each field as defined
      // in field.schema.multipleOf.
      positionStepSize: 0.5,

      positionXDecreaseHeld: false,
      positionXDecreaseHeldTimer: null,
      positionXIncreaseHeld: false,
      positionXIncreaseHeldTimer: null,

      positionYDecreaseHeld: false,
      positionYDecreaseHeldTimer: null,
      positionYIncreaseHeld: false,
      positionYIncreaseHeldTimer: null,
    };
  },
  watch: {
    showPositionButtonsMenu: function (show) {
      if (!show) {
        this.stopAllTimers();
      }
    },
  },
  computed: {
    positionXStepSize() {
      if (this.positionXField && this.positionXField.schema.multipleOf) {
        return this.positionXField.schema.multipleOf;
      }
      return this.positionStepSize;
    },
    positionYStepSize() {
      if (this.positionYField && this.positionYField.schema.multipleOf) {
        return this.positionYField.schema.multipleOf;
      }
      return this.positionStepSize;
    },
  },
  methods: {
    onPositionResetClicked() {
      this.stopAllTimers();
      this.positionXField.value = this.positionXField.default_value || 0;
      this.positionYField.value = this.positionYField.default_value || 0;
      this.$emit('changed');
    },
    stopAllTimers() {
      for (const timerAttr of [
        'positionXDecreaseHeldTimer',
        'positionXIncreaseHeldTimer',
        'positionYDecreaseHeldTimer',
        'positionYIncreaseHeldTimer',
      ]) {
        if (this[timerAttr] !== null) {
          clearTimeout(this[timerAttr]);
          this[timerAttr] = null;
        }
      }
    },
    makePositionMouseDownHandler(vm, heldAttr, timerAttr, field, step) {
      function onMouseDown() {
        vm[heldAttr] = true;

        function tick() {
          field.value += step;
          vm.$emit('changed');

          vm[timerAttr] = setTimeout(() => {
            tick();
          }, 16.67); // 60 fps
        }

        tick();
      }
      return onMouseDown;
    },
    makePositionMouseUpHandler(vm, heldAttr, timerAttr) {
      function onMouseUp() {
        vm[heldAttr] = false;
        if (vm[timerAttr]) {
          clearTimeout(vm[timerAttr]);
          vm[timerAttr] = null;
        }
      }
      return onMouseUp;
    },
    onPositionXDecreaseMouseDown() {
      const handler = this.makePositionMouseDownHandler(
        this,
        'positionXDecreaseHeld',
        'positionXDecreaseHeldTimer',
        this.positionXField,
        -this.positionXStepSize
      );
      return handler();
    },
    onPositionXDecreaseMouseUp() {
      const handler = this.makePositionMouseUpHandler(
        this,
        'positionXDecreaseHeld',
        'positionXDecreaseHeldTimer'
      );
      return handler();
    },
    onPositionXIncreaseMouseDown() {
      const handler = this.makePositionMouseDownHandler(
        this,
        'positionXIncreaseHeld',
        'positionXIncreaseHeldTimer',
        this.positionXField,
        this.positionXStepSize
      );
      return handler();
    },
    onPositionXIncreaseMouseUp() {
      const handler = this.makePositionMouseUpHandler(
        this,
        'positionXIncreaseHeld',
        'positionXIncreaseHeldTimer'
      );
      return handler();
    },
    onPositionYDecreaseMouseDown() {
      const handler = this.makePositionMouseDownHandler(
        this,
        'positionYDecreaseHeld',
        'positionYDecreaseHeldTimer',
        this.positionYField,
        -this.positionYStepSize
      );
      return handler();
    },
    onPositionYDecreaseMouseUp() {
      const handler = this.makePositionMouseUpHandler(
        this,
        'positionYDecreaseHeld',
        'positionYDecreaseHeldTimer'
      );
      return handler();
    },
    onPositionYIncreaseMouseDown() {
      const handler = this.makePositionMouseDownHandler(
        this,
        'positionYIncreaseHeld',
        'positionYIncreaseHeldTimer',
        this.positionYField,
        this.positionYStepSize
      );
      return handler();
    },
    onPositionYIncreaseMouseUp() {
      const handler = this.makePositionMouseUpHandler(
        this,
        'positionYIncreaseHeld',
        'positionYIncreaseHeldTimer'
      );
      return handler();
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/overlayDataPositionButtons.js